import { CapabilityRoleRepository } from "@domain/capability-role/repositories/capability-role.repository";
import { CapabilityRoleRepositoryService } from "../repositories/capability-role.service";

export const CapabilityRoleProvider = [
  {
    provide: CapabilityRoleRepository,
    useClass: CapabilityRoleRepositoryService,
  },
];
